import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

const PromoRecommendationFormLazy = loadable(
    () => import(/* webpackChunkName: "Promoactions" */ './PromoRecommendationFormSuspense')
);

export const PromoRecommendationFormAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <PromoRecommendationFormLazy />
    </DelayedSuspense>
);
